import Axios from "axios";
/* function parseJSON(response) {
  return response.json();
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}
 */
export default function request(url, options) {
  options = options || {};
  options.headers = options.headers || {};
  options.headers['Authorization'] = `Bearer ${localStorage.id_token}`
  return Axios(url, options)
}